import { render, staticRenderFns } from "./wkjq.vue?vue&type=template&id=052198fd&scoped=true&"
import script from "./wkjq.vue?vue&type=script&lang=js&"
export * from "./wkjq.vue?vue&type=script&lang=js&"
import style0 from "./wkjq.vue?vue&type=style&index=0&id=052198fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052198fd",
  null
  
)

export default component.exports